<mat-form-field subscriptSizing="dynamic"
                class="st-address-form-field"
                cdkOverlayOrigin
                #trigger="cdkOverlayOrigin">
    <mat-label>{{appService.languageSettings.PSTWebFormattedAddressLabel}}</mat-label>
    <input matInput
           class="st-address-form-field-input"
           (input)="searchForPlaces($event)"
           (focus)="onFocus($event)"
           [matAutocomplete]="auto"
           [formControl]="internalFormControl"
           [required]="required"
           [placeholder]="label || placeholder"
           [value]="value?.isManualEditMode ? value?.formattedAddress : value?.title">
    <button mat-icon-button
            matSuffix
            (click)="isPanelOpen=true"
            click-stop-propagation
            [disabled]="disabled">
        <mat-icon class="material-symbols-outlined">edit_location</mat-icon>
    </button>
    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)="selectPrediction($event.option.value)"
                      [displayWith]="displayWith">
        <mat-option *ngFor="let result of predictions"
                    [value]="result"
                    class="st-address-form-item">
            <mat-icon class="material-symbols-outlined">place</mat-icon>
            <span class="st-address-form-title">
                <span class="st-address-form-title-matched">{{result.structured_formatting.main_text}}</span>
                <span class="st-address-form-title-secondary">{{result.structured_formatting.secondary_text}}</span>
            </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="trigger"
             [cdkConnectedOverlayOpen]="isPanelOpen"
             (overlayOutsideClick)="close()"
             click-stop-propagation>
    <div class="st-address-form-details-fields"
         click-stop-propagation>
        <text-field class="st-address-form-details-fields-item"
                    [value]="value.streetAddress"
                    (changed)="internalAddressChanged($event)"
                    [label]="appService.languageSettings.PSTWebStreetAddressPlaceholder"
                    [placeholder]="appService.languageSettings.PSTWebStreetAddressPlaceholder">
        </text-field>

        <text-field class="st-address-form-details-fields-item"
                    [value]="value.locationName"
                    (changed)="internalLocationChanged($event)"
                    [label]="appService.languageSettings.PSTWebLocationNamePlaceholder"
                    [placeholder]="appService.languageSettings.PSTWebLocationNamePlaceholder">
        </text-field>

        <text-field [value]="value.city"
                    (changed)="internalCityChanged($event)"
                    [label]="appService.languageSettings.PSTWebCityPlaceholder"
                    [placeholder]="appService.languageSettings.PSTWebCityPlaceholder">
        </text-field>

        <text-field [value]="value.state"
                    (changed)="internalStateChanged($event)"
                    [label]="appService.languageSettings.PSTWebStatePlaceholder"
                    [placeholder]="appService.languageSettings.PSTWebStatePlaceholder">
        </text-field>

        <text-field [value]="value.country"
                    (changed)="internalCountryChanged($event)"
                    [label]="appService.languageSettings.PSTWebCountryPlaceholder"
                    [placeholder]="appService.languageSettings.PSTWebCountryPlaceholder">
        </text-field>
    </div>
</ng-template>
